/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageMetadata } from './page-metadata';
import { TipoPraticaIstitutoPlessoDTO } from './tipo-pratica-istituto-plesso-dto';


export interface PagedModelTipoPraticaIstitutoPlessoDTO { 
    content?: Array<TipoPraticaIstitutoPlessoDTO>;
    page?: PageMetadata;
}

